import postWithToken from './base/post-with-token'

const customerUpdateNote = (id, data) => postWithToken(`/customer-timeline/note/${id}`)(data)

export default customerUpdateNote